import user from './user';
import topList from './topList';
import watchList from './watchList';

export default {
    topList,
    watchList,
    user
};